"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartRegularCheckoutPayment = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackCartRegularCheckoutPayment(label) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.ClickEventType.BUTTON_CLICK,
        eventLabel: label,
    });
}
exports.trackCartRegularCheckoutPayment = trackCartRegularCheckoutPayment;
//# sourceMappingURL=trackCartRegularCheckoutPayment.js.map